import { create } from 'zustand';
import { ICreator } from '~/types';

export interface IUseSelectCreatorContentContentStore {
  creator?: ICreator;
  isModalOpen: boolean;
  onModalClose: () => void;
  onModalOpen: (creator: ICreator) => void;
  setCreator: (creator: ICreator) => void;
}

export const useSelectCreatorContentStore =
  create<IUseSelectCreatorContentContentStore>((set) => ({
    isModalOpen: false,
    onModalClose: () => set(() => ({ isModalOpen: false, creator: undefined })),
    onModalOpen: (creator) => set(() => ({ isModalOpen: true, creator })),
    setCreator: (creator) => set(() => ({ creator })),
  }));
